/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChargePaymentMethodResponse
 */
export interface ChargePaymentMethodResponse {
    /**
     * Stripe PaymentIntent id (`pi_xxx`). Null when the charge never created an intent (e.g. card declined at PaymentMethod attach step).
     * @type {string}
     * @memberof ChargePaymentMethodResponse
     */
    paymentIntentId?: string | null;
    /**
     * Stripe PaymentIntent.status, mirrored from `ChargeResult.status`. Typical values when status is set — `succeeded`, `requires_action`, `declined`, `requires_payment_method`. Callers should branch on `succeeded` first.
     * @type {string}
     * @memberof ChargePaymentMethodResponse
     */
    status?: string | null;
    /**
     * Charge amount in minor units (cents for two-decimal currencies). Matches Stripe's wire format.
     * @type {number}
     * @memberof ChargePaymentMethodResponse
     */
    amountCents: number;
    /**
     * ISO currency code echoed back from the charge.
     * @type {string}
     * @memberof ChargePaymentMethodResponse
     */
    currency: string;
    /**
     * True iff `status == "succeeded"` — the only state where the booking flow may proceed with supplier book-out.
     * @type {boolean}
     * @memberof ChargePaymentMethodResponse
     */
    succeeded: boolean;
    /**
     * User-facing error message when the charge didn't succeed (e.g. "Your card was declined.").
     * @type {string}
     * @memberof ChargePaymentMethodResponse
     */
    errorMessage?: string | null;
    /**
     * Stripe `error.code` (e.g. `card_declined`, `expired_card`). Set only on failure.
     * @type {string}
     * @memberof ChargePaymentMethodResponse
     */
    errorCode?: string | null;
    /**
     * Stripe `error.decline_code` (e.g. `fraudulent`, `insufficient_funds`). Set only on `card_declined`.
     * @type {string}
     * @memberof ChargePaymentMethodResponse
     */
    declineCode?: string | null;
}

/**
 * Check if a given object implements the ChargePaymentMethodResponse interface.
 */
export function instanceOfChargePaymentMethodResponse(value: object): value is ChargePaymentMethodResponse {
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('succeeded' in value) || value['succeeded'] === undefined) return false;
    return true;
}

export function ChargePaymentMethodResponseFromJSON(json: any): ChargePaymentMethodResponse {
    return ChargePaymentMethodResponseFromJSONTyped(json, false);
}

export function ChargePaymentMethodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChargePaymentMethodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIntentId': json['payment_intent_id'] == null ? undefined : json['payment_intent_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'amountCents': json['amount_cents'],
        'currency': json['currency'],
        'succeeded': json['succeeded'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'errorCode': json['error_code'] == null ? undefined : json['error_code'],
        'declineCode': json['decline_code'] == null ? undefined : json['decline_code'],
    };
}

export function ChargePaymentMethodResponseToJSON(json: any): ChargePaymentMethodResponse {
    return ChargePaymentMethodResponseToJSONTyped(json, false);
}

export function ChargePaymentMethodResponseToJSONTyped(value?: ChargePaymentMethodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_intent_id': value['paymentIntentId'],
        'status': value['status'],
        'amount_cents': value['amountCents'],
        'currency': value['currency'],
        'succeeded': value['succeeded'],
        'error_message': value['errorMessage'],
        'error_code': value['errorCode'],
        'decline_code': value['declineCode'],
    };
}

